import { createContext, useContext, useState, useEffect } from 'react'

const STORAGE_KEY = 'enablar-current-user'

interface CurrentUserContextValue {
  currentUser: string | null
  isReady: boolean
  setCurrentUser: (name: string) => void
  clearCurrentUser: () => void
}

const CurrentUserContext = createContext<CurrentUserContextValue | null>(null)

export function CurrentUserProvider({ children }: { children: React.ReactNode }) {
  const [currentUser, setCurrentUserState] = useState<string | null>(null)
  const [isReady, setIsReady] = useState(false)

  useEffect(() => {
    setCurrentUserState(localStorage.getItem(STORAGE_KEY))
    setIsReady(true)
  }, [])

  function setCurrentUser(name: string) {
    localStorage.setItem(STORAGE_KEY, name)
    setCurrentUserState(name)
  }

  function clearCurrentUser() {
    localStorage.removeItem(STORAGE_KEY)
    setCurrentUserState(null)
  }

  return (
    <CurrentUserContext.Provider value={{ currentUser, isReady, setCurrentUser, clearCurrentUser }}>
      {children}
    </CurrentUserContext.Provider>
  )
}

export function useCurrentUser() {
  const ctx = useContext(CurrentUserContext)
  if (!ctx) throw new Error('useCurrentUser must be used within CurrentUserProvider')
  return ctx
}
